import { GetPowersListQuery, useGetPowersListQuery } from './generated';
import { unwrapQuery } from './unwrap';

export const useGetEmployeePowersQuery = (...args: Parameters<typeof useGetPowersListQuery>) =>
  unwrapQuery(
    useGetPowersListQuery(...args),
    (raw: GetPowersListQuery | undefined) => raw?.coreEmployeePowers?.getPowersList,
  );
